namespace TabAurous.Retail {
    export interface POSApprovalForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        CustomerName: Serenity.StringEditor;
        Address: Serenity.TextAreaEditor;
        Mobile: Serenity.IntegerEditor;
        PanNumber: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        MF: Serenity.DecimalEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: POSApprovalItemsEditor;
        ReceiptDetails: ApprovalReceiptDetailsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        ReceiptAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class POSApprovalForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.POSApproval';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSApprovalForm.init)  {
                POSApprovalForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = s.TextAreaEditor;
                var w6 = s.LookupEditor;
                var w7 = s.DecimalEditor;
                var w8 = s.ImageUploadEditor;
                var w9 = POSApprovalItemsEditor;
                var w10 = ApprovalReceiptDetailsEditor;

                Q.initFormType(POSApprovalForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'POSCustomerId', w4,
                    'CustomerName', w2,
                    'Address', w5,
                    'Mobile', w3,
                    'PanNumber', w2,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'BirthDate', w0,
                    'Anniversary', w0,
                    'CurrencyId', w6,
                    'ExchRate', w7,
                    'UserId', w6,
                    'EmployeeId', w3,
                    'MF', w7,
                    'ProductItemImage', w8,
                    'ItemDetails', w9,
                    'ReceiptDetails', w10,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w7,
                    'NetWeight', w7,
                    'NetAmount', w7,
                    'CCNetAmount', w7,
                    'ReceiptAmount', w7,
                    'Discount', w7,
                    'AdditionalCharges', w7,
                    'GrossAmount', w7,
                    'CCGrossAmount', w7,
                    'Remark', w5,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
